export const SHOW_AUTHOR = "SHOW_AUTHOR";
export const SHOW_LETTERS = "SHOW_LETTERS";
export const SHOW_INIT_INSTRUCTIONS = "SHOW_INIT_INSTRUCTIONS";